import type { ReactionAgg } from '../../../types/chat';

interface ReactionBarProps {
  reactions: ReactionAgg[];
  /** chip 클릭 → 해당 이모지 토글. */
  onToggle: (emoji: string) => void;
}

/**
 * ReactionBar — 메시지 말풍선 아래 이모지 반응 chips (presentational).
 *
 * mine 인 chip 은 강조. 클릭 시 onToggle(상위가 toggleReaction + 로컬 반영).
 * 반응 0 이면 렌더 안 함.
 */
export function ReactionBar({ reactions, onToggle }: ReactionBarProps) {
  if (reactions.length === 0) return null;
  return (
    <div className="chat-reaction-bar">
      {reactions.map((r) => (
        <button
          key={r.emoji}
          type="button"
          className={`chat-reaction-chip${r.mine ? ' chat-reaction-chip--mine' : ''}`}
          onClick={() => onToggle(r.emoji)}
          aria-label={`${r.emoji} ${r.count}${r.mine ? ' (내 반응)' : ''}`}
          aria-pressed={r.mine}
        >
          <span className="chat-reaction-chip-emoji">{r.emoji}</span>
          <span className="chat-reaction-chip-count">{r.count}</span>
        </button>
      ))}
    </div>
  );
}
